import React from 'react'
import { toast } from 'react-toastify'
import AlertIcon from './../../../assets/alert.png'
import SuccessIcon from './../../../assets/Success.png'

interface CustomToastProps {
  type: 'success' | 'error'
  heading: string
  message: string | undefined
  autoClose?: number
}

const CustomToast: React.FC<CustomToastProps> = ({
  type,
  heading,
  message,
  autoClose = 5000
}) => {
  const customToastStyle: React.CSSProperties = {
    background: 'var(--background-dark-component-container-1, #272727)',
    boxShadow:
      '0px 11px 15px -2px rgba(0, 0, 0, 0.25), 15px 30px 40px 0px rgba(0, 0, 0, 0.40)'
  }
  const customToastClassName = 'custom-toast-class'

  const icon = type === 'success' ? SuccessIcon : AlertIcon
  const toastType = type === 'success' ? 'Success' : 'Error'

  toast(
    <div className={`toaster-message ${customToastClassName}`}>
      <div className={`toaster-${type}-header`}>
        <img alt={`${type}-icon`} src={icon} />
        <span className="toaster-type-text">{toastType}</span>
      </div>
      <div>
        <p className="toaster-heading">{heading}</p>
        <span className="toaster-message">{message}</span>
      </div>
    </div>,
    {
      position: 'bottom-right',
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
      theme: 'dark',
      className: customToastClassName,
      style: {
        ...customToastStyle
      }
    }
  )

  return null
}

export default CustomToast
